import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


const API_URL = environment.apiUrl;
const API_VERSION = environment.MSImagingProjectVersion;
const SERVICE = 'msimagingproject-dot-';
const requestURL = 'https://' + API_VERSION + SERVICE + API_URL;

@Injectable({
  providedIn: 'root'
})
export class SequenceLabelService {

  constructor(private http: HttpClient) { }

  create(sequenceLabel: any) {
    return this.http.post(requestURL + `/sequence-label`, sequenceLabel);
  }

  update(sequenceLabel: any) {
    return this.http.put(requestURL + `/sequence-label`, sequenceLabel);
  }

  delete(id: number) {
    return this.http.delete(requestURL + `/sequence-label/` + id);
  }

  getById(id: number) {
    return this.http.get(requestURL + `/sequence-label/` + id);
  }

  getAll() {
    return this.http.get(requestURL + `/sequence-label/retrieve-all`);
  }
}
